import { Button } from 'components/atoms/Button';
import useResolveFileURL from 'hooks/useResolveFileURL';
import type { FC } from 'react';
import { useCallback } from 'react';
import type { ConversationMetadata } from 'types/ai.types';
import { openInNewTab } from 'utils/helpers';

type AIMessageMetadataFileProps = {
  metadata: ConversationMetadata;
};

const AIMessageMetadataFile: FC<AIMessageMetadataFileProps> = ({
  metadata,
}) => {
  const { data: fileUrl } = useResolveFileURL(
    metadata?.data.filePath as string,
  );

  const onClick = useCallback(() => {
    if (!fileUrl?.url) return;
    openInNewTab(fileUrl.url);
  }, [fileUrl?.url]);

  return (
    <Button
      className="flex flex-row items-center gap-2 rounded-md bg-white p-2.5 mb-3 font-bold cursor-pointer"
      onClick={onClick}
      asDefault
    >
      <p className="text-[#EF4444] bg-[#F6F6F6] h-9 w-9 flex items-center justify-center rounded-md border-b border-[#EBEBEB]">
        {metadata?.documentType === 'pdf' ? 'PDF' : 'IMG'}
      </p>
      <p>{metadata.data.originalFilename}</p>
    </Button>
  );
};
export default AIMessageMetadataFile;
